// extracted by mini-css-extract-plugin
export default {"base":"Navigation_base__EakMQ"};